module.exports = __webpack_public_path__ + "img/5-icono-cancelados.526b463d.svg";